import { getImageUrl, isDateLaterNow } from 'src/app/common/app.helpers';
import ProjectLinks from 'src/app/common/project.links';

import { entityBasedCommunityLink } from 'src/app/components/community/community.helpers';
import { getStatus } from 'src/app/components/profile/user-profile/view-profile/regular-user-profile/regular-user-profile-helper';
import { CustomMarkerData } from 'src/app/interfaces/map.interface';
import { EntityStatus, ItemStatus } from 'src/app/interfaces/views.interface';
import { Community, CommunityStatus, Project } from 'src/app/swagger-api';
import MapSettings from '../../map.settings';
import { getLocation } from '../../shared/location.service';
import { NonAggregatedMarkerBuilder } from './non-aggregated-items-marker.builder';

export abstract class SocialInitiativeMarkerBuilder<
  TEntity extends { entity_id: string },
> extends NonAggregatedMarkerBuilder<TEntity> {
  protected abstract getLink(data: TEntity): string;

  protected abstract getStatus(data: TEntity): EntityStatus;

  public getMarkerId(data: TEntity): string {
    return data.entity_id;
  }
}

export class CommunityMarkerBuilder extends SocialInitiativeMarkerBuilder<Community> {
  public override getIconUrl(): string {
    return MapSettings.COMMUNITY_MARKER_ICON_URL;
  }

  protected getLink(data: Community): string {
    return entityBasedCommunityLink(data);
  }

  protected getStatus(data: Community): EntityStatus {
    return data.status === CommunityStatus.Closed ? ItemStatus.PRIVATE : ItemStatus.EMPTY;
  }

  protected getCustomMarkerData(data: Community): CustomMarkerData {
    return {
      user: {
        userId: data.creator.user_id,
        displayedName: data.creator.displayed_name,
        status: getStatus(data.creator),
        image: getImageUrl(data.creator.image_url),
      },
      title: data.title,
      status: this.getStatus(data),
      specialization: data.key_categories,
      displayedLocation: getLocation(data.location),
      routerLink: this.getLink(data),
    };
  }
}

export class ProjectMarkerBuilder extends SocialInitiativeMarkerBuilder<Project> {
  public override getIconUrl(): string {
    return MapSettings.PROJECT_MARKER_ICON_URL;
  }

  protected getLink(_data: Project): string {
    return ProjectLinks.LINK_PROJECTS_VIEW;
  }

  protected getStatus(data: Project): EntityStatus {
    return isDateLaterNow(data.validity_period?.end_date) ? ItemStatus.EXPIRED : ItemStatus.EMPTY;
  }

  protected getCustomMarkerData(data: Project): CustomMarkerData {
    return {
      user: {
        userId: data.creator.user_id,
        displayedName: data.creator.displayed_name,
        status: getStatus(data.creator),
        image: getImageUrl(data.creator.image_url),
      },
      title: data.title,
      status: this.getStatus(data),
      specialization: data.specialities,
      displayedLocation: getLocation(data.location),
      routerLink: `${this.getLink(data)}/${data.entity_id}`,
    };
  }
}
